<template>
    <div class="flex flex-row w-full flex-wrap">
        <spinner class="w-full m-24" v-if="isLoading"/>
        <div class="flex"  v-if="!isLoading"><NewAlbumButton/></div>
        <div class="flex" v-for="album in albums" :id="album.id" :name="album.title" :key="album.id"  v-if="!isLoading">
            <a :href="album.href" @click="selectAlbum(album)">
                <album :id="album.id" :title="album.title" :cover="album.cover "/>
            </a>
        </div>
    </div>
</template>

<script>
import Spinner from "vue-simple-spinner";
import AlbumsRepository from "../repositories/AlbumsRepository";
import Album from "./Album";
import NewAlbumButton from './NewAlbumButton';

export default {
  components: {
    Album,
    NewAlbumButton,
    Spinner
  },
  name: "Albums",
  data() {
    return {
      albums: [],
      isLoading: true
    };
  },

  created() {
    AlbumsRepository.getUserAlbums(albums => {
      this.albums = albums;
      this.isLoading = false;
    });
  },

  methods: {
    selectAlbum(selectedAlbum) {
      this.albums.forEach(album => {
        album.isActive = album.href === selectedAlbum.href;
      });
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Albums.vue